import { render, staticRenderFns } from "./NotificationToolbarMenu.vue?vue&type=template&id=31c7de12&scoped=true"
import script from "./NotificationToolbarMenu.vue?vue&type=script&lang=js"
export * from "./NotificationToolbarMenu.vue?vue&type=script&lang=js"
import style0 from "./NotificationToolbarMenu.vue?vue&type=style&index=0&id=31c7de12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c7de12",
  null
  
)

export default component.exports